import { Tooltip } from '@mui/material';
import { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { EBackupImage } from '../enums/shared/EBackupImage';
import { ETheme } from '../enums/user/ETheme';
import { getFallbackImageSource } from '../functions/getFallbackImageSource';

interface IProps {
  src: string;
  alt: string;
  onClick?: () => void;
  className?: string;
  style?: CSSProperties | undefined;
  fallbackType?: EBackupImage;
  tooltipTitle?: string;
}

export const ImageHandler: React.FC<IProps> = ({
  src,
  alt,
  onClick,
  className,
  style,
  fallbackType = EBackupImage.OTHER,
  tooltipTitle,
}) => {
  const { userData } = useSelector((state: RootState) => state.auth);
  const isDark = userData?.theme === ETheme.DARK;
  return (
    <Tooltip title={tooltipTitle}>
      <img
        src={src}
        alt={alt}
        onClick={onClick}
        style={style}
        className={className}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.src = getFallbackImageSource(fallbackType, isDark);
        }}
      />
    </Tooltip>
  );
};
